import {post, get} from './fetch.js'
export default {
  home: {
    MessageValidation(params, head) {
      return post(`/CoreService/K3UserInfo/MessageValidation`, params, head,)
    },
    UpdateQyUserInfo(params, head) {
      return post(`/CoreService/K3UserInfo/UpdateQyUserInfo`, params, head,)
    },

    AddUserGzjl(params, head) {
      return post(`/CoreService/K3UserInfo/AddUserGzjl`, params, head,)
    },
    AddUserZzyry(params, head) {
      return post(`/CoreService/K3UserInfo/AddUserZzyry`, params, head,)
    },
    EditUserZzyry(params, head) {
      return post(`/CoreService/K3UserInfo/EditUserZzyry`, params, head,)
    },
    EditUserGzjl(params, head) {
      return post(`/CoreService/K3UserInfo/EditUserGzjl`, params, head,)
    },
    UpdateUserQwgw(params, head) {
      return post(`/CoreService/K3Gwjh/UpdateUserQwgw`, params, head,)
    },
    FindMyK3Activitys(params, head) {
      return get(`/CoreService/K3Activity/FindMyK3Activitys`, params, head,)
    },
    //岗位申请接口
    SqGwQuestion(params, head) {
      return post(`/CoreService/K3Gwjh/SqGwQuestion`, params, head,)
    },
    //企业名称接口
    GlkhName(params, head) {
      return get(`/CoreService/K3Gwjh/GlkhName`, params, head,)
    },
    //修改面试时间
    EditMsDate(params, head) {
      return post(`/CoreService/K3Gwjh/EditMsDate`, params, head,)
    },
    //岗位问答题
    FindOneQuestion(params, head) {
      return get(`/CoreService/K3Gwjh/FindOneQuestion`, params, head,)
    },
    //活动列表
    FindAllK3Activity(params, head) {
      return get(`/CoreService/K3Activity/FindAllK3Activity`, params, head,)
    },
    //获取我的全部申请岗位
    FindMyGwjhs(params, head) {
      return get(`/CoreService/K3Gwjh/FindMyGwjhs`, params, head,)
    },
    //获取一条活动信息
    FindOneK3Activity(params, head) {
      return get(`/CoreService/K3Activity/FindOneK3Activity`, params, head,)
    },
    //提交
    SaveActivityCy(params, head) {
      return post(`/CoreService/K3Activity/SaveActivityCy`, params, head,)
    },
    //岗位问答题
    SumbitQuestionDA(params, head) {
      return post(`/CoreService/K3Gwjh/SumbitQuestionDA`, params, head,)
    },
    //获取面试结果通知单
    FindUserMsjg(params, head) {
      return get(`/CoreService/K3Gwjh/FindUserMsjg`, params, head,)
    },
    //获取邀请知单
    FindUserMsTzd(params, head) {
      return get(`/CoreService/K3Gwjh/FindUserMsTzd`, params, head,)
    },
    //获取code，判断是否登录
    GetUserOpenIdByCode(params, head) {
      return get(`/CoreService/K3UserInfo/GetUserOpenIdByCode`, params, head,)
    },
    //订单产品大类
    FCobCPDLs(params, head) {
      return get(`/CoreService/K3Service/FCobCPDLs`, params, head,)
    },
    //查询关于当前用户联系人列表
    FindMyUserContacts(params, head) {
      return get(`/CoreService/K3Service/FindMyUserContacts`, params, head,)
    },
    //订单详情
    EditOrder(params, head) {
      return post(`/CoreService/K3Service/EditOrder`, params, head,)
    },
    //查询全部
    FindFaults(params, head) {
      return get(`/CoreService/K3Service/FindFaults`, params, head,)
    },
    //查询分类
    SearchFault(params, head) {
      return get(`/CoreService/K3Service/SearchFault`, params, head,)
    },
    //添加用户联系人
    AddUserContact(params, head) {
      return post(`/CoreService/K3Service/AddUserContact`, params, head,)
    },
    //获取code，判断是否登录
    XlMore(params, head) {
      return get(`/CoreService/K3Service/XlMore`, params, head,)
    },
     //插入订单
     SaveOrder(params, head) {
      return post (`/CoreService/K3Service/SaveOrder`, params, head,)
    },
    //预约维修添加
    AddYyWx(params, head) {
      return post (`/CoreService/K3Order/AddYyWx`, params, head,)
    },

    //预约测绘添加
    AddYyCh(params, head) {
      return post (`/CoreService/K3Order/AddYyCh`, params, head,)
    },
    //预约交流添加
    AddYyJl(params, head) {
      return post (`/CoreService/K3Order/AddYyJl`, params, head,)
    },
    //预约安装添加
    AddYyAz(params, head) {
      return post (`/CoreService/K3Order/AddYyAz`, params, head,)
    },
    //满意度评价
    OrderPj(params, head) {
      return post (`/CoreService/K3Order/OrderPj`, params, head,)
    },
    //完善个人基础信息
    UpdateUserInfo(params, head) {
      return post (`/CoreService/K3UserInfo/UpdateUserInfo`, params, head,)
    },
    //获取全部岗位机会
    FindGwjhs(params, head) {
      return get (`/CoreService/K3Gwjh/FindGwjhs`, params, head,)
    },
    //查询单条个人用户信息
    GetUserInfoByFNumber(params, head) {
      return get (`/CoreService/K3UserInfo/GetUserInfoByFNumber`, params, head,)
    },
    //用户类型验证
    UpdateUserType(params, head) {
      return post (`/CoreService/K3UserInfo/UpdateUserType`, params, head,)
    },
    //进度
    FindQuestionMessage(params, head) {
      return get (`/CoreService/K3Gwjh/FindQuestionMessage`, params, head,)
    },
    //查询单条个人用户信息
    FindOneUserInfo(params, head) {
      return get (`/CoreService/K3Service/FindOneUserInfo?`, params, head,)
    },
    //查询一条预约安装
    FindYyAz(params, head) {
      return get (`/CoreService/K3Order/FindYyAz`, params, head,)
    },
    //预约维修详情
    FindYyWx(params, head) {
      return get (`/CoreService/K3Order/FindYyWx`, params, head,)
    },
    //预约测绘
    FindYyCh(params, head) {
      return get (`/CoreService/K3Order/FindYyCh`, params, head,)
    },
   //预约交流
    FindYyJl(params, head) {
      return get (`/CoreService/K3Order/FindYyJl`, params, head,)
    },
    //查询报装保修类订单列表
    FindBzBxList(params, head) {
      return post (`/CoreService/K3Order/FindOrderByParam`, params, head,)
    },
    //获取一条岗位机会问题
    FindOneGwjh(params, head) {
      return get (`/CoreService/K3Gwjh/FindOneGwjh`, params, head,)
    },


     //  查询订单
    FindOrderByTj(params, head){
      return get (`/CoreService/K3Service/FindOrderByTj`, params, head,)
    },
    // 查询一条订单 暂时用的
    FindOneOrder(params, head){
      return get (`/CoreService/K3Service/FindOneOrder`, params, head,)
    },
    // CoreService/K3Service/AddOrderFFAZX 追加  咨询订单 又叫添加咨询订单
    AddOrderFFAZX(params, head){
      return post (`/CoreService/K3Service/AddOrderFFAZX`, params, head,)
    },
    //
    // 选型估价保存接口
    SaveXxGj(params, head){
      return post (`/CoreService/K3Order/SaveXxGj`, params, head,)
    },
    // 服务申请 选型估价 方案咨询 产品订单
    FBillTypeIds(params, head) {
      return get(`/CoreService/K3Service/FBillTypeIds`, params, head,)
    },
    // 单据通用列表查询
    FindOrderByParam(params, head){
      return post(`/CoreService/K3Order/FindOrderByParam`, params, head,)
    },
    // 查找一条方案咨询
    FindOneFaZx(params, head){
      return get(`/CoreService/K3Order/FindOneFaZx`, params, head,)
    },
    // 获取一条选型估价
    FindOneXxGjOrder(params, head){
      return get(`/CoreService/K3Order/FindOneXxGjOrder`, params, head,)
    },
    // 获取一条产品订单
    FindOneCpDd(params, head){
      return get(`/CoreService/K3Order/FindOneCpDd`, params, head,)
    },
    // 方案咨询
    SaveFaZx(params, head){
      return post(`/CoreService/K3Order/SaveFaZx`, params, head,)
    },
    // 产品订单
    SaveCpDd(params, head){
      return post(`/CoreService/K3Order/SaveCpDd`, params, head,)
    },
    // 撤销订单
    UnAuditOrder(params, head){
      return post(`/CoreService/K3Order/UnAuditOrder`, params, head,)
    },
    UploadFile(params, head){
      return post(`/CoreService/File/UploadFile`, params, head,)
    },
    // 获取泵位号
    FindBwhs(params, head){
      return get(`/CoreService/K3Order/FindBwhs`, params, head,)
    },
    // 查询一条企业用户
    GetQyUserInfoByFNumber(params, head){
      return get(`/CoreServiceService/K3UserInfo/GetQyUserInfoByFNumber`, params, head,)
    },
    // 微信信息
    GetWeInfo(params, head){
      return get(`/CoreService/K3UserInfo/GetWeInfo`, params, head,)
    },
    // 扫一扫
    FindOneQcNumber(params, head){
      return get(`/ CoreService/K3Order/FindOneQcNumber`, params, head,)
    },
    MessageGet(params, head){
      return post(`/CoreService/Login/MessageGet`, params, head,)
    },
    FindMyMessageList(params, head){
      return get(`/CoreService/K3Gwjh/FindMyMessageList`, params, head,)
    },
    FindOneMessage(params, head){
      return get(`/CoreService/K3Gwjh/FindOneMessage`, params, head,)
    },
    FindAllNew(params, head){
      return get(`/CoreService/K3New/FindAllNew`, params, head,)
    },
    UpdateQwInfo(params, head){
      return post(`/CoreService/K3UserInfo/UpdateQwInfo`, params, head,)
    },
    // 获取消息列表/api/CoreService/K3Gwjh/FindMyMessageList?number=13598033891
    // 获取单条消息列表/api/CoreService/K3Gwjh/FindOneMessage?number=20200406161334320
   

    // /CoreService/K3Order/FindOneCpDd


//     [
// {
// "key": "WWZKHXTD_FWSQ",
// "value": "服务申请"
// },
// {
// "key": "WWZKHXTD_XXGJ",
// "value": "选型估价"
// },
// {
// "key": "WWZKHXTD_FAZX",
// "value": "方案咨询"
// },
// {
// "key": "WWZKHXTD_CPDD",
// "value": "产品订单"
// }
// ]
  }
}



// WEBPACK FOOTER //
// ./src/service/service.js